import React, { useState, useRef } from 'react';
import { Button, makeStyles } from '~/lib/bn-material-ui';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import OrderSuggestionSnoozeDialog from '../orders/order-suggestion-snooze-settings';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: theme.palette.gray[20],
    padding: '.5rem 1.5rem',
  },
  statusText: {
    fontWeight: 'bold',
    marginLeft: '.25rem',
  },
  settingsButton: {
    padding: '.125rem .25rem',
    marginLeft: '.5rem',
  },
}));

export default function OrderSuggestionSettingsBar({ binHref }) {
  const styles = useStyles();
  const container = useRef();
  const { entity: binEntity } = useSirenEntity({ href: binHref });
  const { entity: ordersEntity } = useSirenEntity({ href: binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/orders')?.href });
  const settingsHref = ordersEntity?.getLinkByRel('https://api.binsentry.com/rel/order-suggestion-settings')?.href;
  const { entity: settingsEntity } = useSirenEntity({ href: settingsHref });
  const [showDialog, setShowDialog] = useState(false);

  if (!settingsHref) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div ref={container} />
      {settingsEntity && (<>
        <span>Order Suggestions: </span>
        <span className={styles.statusText}>
          {settingsEntity?.properties?.suggestingOrders ? 'Active' : 'Snoozed'}
        </span>
        <OrderSuggestionSnoozeDialog
          binHref={binHref}
          open={showDialog}
          onClose={() => setShowDialog(false)}
          showUnSnoozedOption={true}
          container={container}
        />
        <Button className={styles.settingsButton} variant='text' onClick={() => setShowDialog(true)}>
          settings
        </Button>
      </>)}
    </div>
  );
}
